// extracted by mini-css-extract-plugin
module.exports = {"authorAvatar":"X6bhs"};